module.exports = __webpack_public_path__ + "media/images/share-campaign.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/share-campaign.png
// module id = 148
// module chunks = 0